(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/draw-info.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/draw-info.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.DrawInfo = Marionette.View.extend({
    className: 'view-draw-info draw-info',

    template: function(data) {
      return svs.matchen.templates.draw_info(data);
    }
  });
})(Backbone, _, svs);


 })(window);